import {Dropdown, Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import {
    SoilProfileTableFilterIcon,
    SoilProfileTableSortIcon
} from '../../resource/IconComponentSets';
import IF from '../../components/IF';
import './index.less';


interface IProps {
  title: string,
  type: 'sort'|'filter'|'none',
  filterIconSide?: 'left' | 'right',
  filterSourceArray?: string[],
  sortCallBack?: (isAscending: boolean) => void,
  filterCallBack?: ({item, title}: { item: string, title: string}) => void,
}

export default function TableHeaderCell(props: IProps = {
    title: 'null',
    filterSourceArray: [],
    filterIconSide: 'left',
    type: 'none'
}) {
    const [mouseEnter, setMouseEnter] = useState(false);
    const [showSortIcon, setShowSortIcon] = useState(false);
    const [showLeftFilterIcon, setShowLeftFilterIcon] = useState(false);
    const [showRightFilterIcon, setShowRightFilterIcon] = useState(false);
    const [sortAscending, setSortAscendingt] = useState(false);

    const {
        title,
        type,
        filterIconSide,
        filterSourceArray,
        sortCallBack,
        filterCallBack
    } = props;

    useEffect(() => {
        if (type === 'filter' && filterIconSide === 'left') {
            if (mouseEnter) {
                setShowLeftFilterIcon(true);
            } else {
                setShowLeftFilterIcon(false);
            }
        }

        if (type === 'filter' && filterIconSide === 'right') {
            if (mouseEnter) {
                setShowRightFilterIcon(true);
            } else {
                setShowRightFilterIcon(false);
            }
        }

        if ( type === 'sort') {
            if (mouseEnter) {
                setShowSortIcon(true);
            } else {
                setShowSortIcon(false);
            }
        }
    }, [mouseEnter]);

    const menuItems = filterSourceArray && filterSourceArray.map((item) => {
        return {
            label: item,
            key: item,
            onClick: () => filterCallBack({ item, title })
        };
    });

    return (
        <div
            onMouseEnter={() => setMouseEnter(true)}
            onMouseLeave={() => setMouseEnter(false)}
            className={'table-header-container'}
            onClick={() => {
                if (type === 'sort') {
                    setSortAscendingt(!sortAscending);
                    sortCallBack(sortAscending);
                }
            }}
        >
            <IF show={type === 'filter' && filterIconSide === 'left'}>
                <Dropdown
                    overlay={<Menu items={menuItems} />}
                    className='filter-icon-left-side'
                >
                    <a
                        onClick={(params) => {
                            console.log('params', params);
                        }}
                    >
                        <SoilProfileTableFilterIcon show={showLeftFilterIcon} />
                    </a>
                </Dropdown>
            </IF>
            <span className='table-header-title-span'>
                <span className='table-header-title-text'>{title}</span>
                <SoilProfileTableSortIcon show={showSortIcon} className='header-sort-icon' />
            </span>
            <IF show={showRightFilterIcon}>
                <Dropdown
                    overlay={<Menu items={menuItems}/>}
                    className='filter-icon-right-side'
                >
                    <a onClick={(params) => {
                        console.log('params', params);
                    }}>
                        <SoilProfileTableFilterIcon show={true} />
                    </a>
                </Dropdown>
            </IF>
        </div>
    );
}